import { CONTAINER, TYPES } from '../../../config';

import { AppState, MutationClass } from '../../../models';

import { StorageService } from '../../../services';

import { APP_CONSTS } from '../app.consts';

export class SetMenuCollapsedMutation implements MutationClass {

  public static execute(state: AppState, menuCollapsed: boolean): void {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService);
    storageService.setItem(APP_CONSTS.storage.menuCollapsed, `${ menuCollapsed }`);
    state.menuCollapsed = menuCollapsed;
  }

}
